<template>
  <div>

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <div class="d-flex">
        <img
          class="back-to-list-apps"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/administrator/layer')"
        >
        <h3 class="label-header-form-ui ellipsis">
          {{ layer_detail ? layer_detail.name : '' }}
        </h3>
        <!-- <b-col>
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10"/>
        </b-col> -->
      </div>
    </div>
    <div class="studio-page-content">
      <div>
        <j-layer-form
          ref="layerForm"
          mode="update"
          @data="getData"/>
      </div>
      <br>
      <div class="flex-column align-items-end">
        <b-button
          class="btn blue m__r--5"
          @click="saveUpdateLayer">
          Update
        </b-button>
        <b-button
          class="btn red"
          @click="onClickDelete">
          Delete
        </b-button>
      </div>
    </div>
  </div>

</template>

<script>
import jLayerForm from '@/views/layer/jLayerForm';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    jLayerForm,
  },
  data() {
    return {
      layer_data: null,
      title: {
        main_title: 'UPDATE LAYER',
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLayer', ['layer_detail']),
    // prepare data form to hit API
    generateData() {
      return {
        id: this.layer_data.id,
        name: this.layer_data.name,
        code: this.layer_data.code,
        layer_head_id: this.layer_data.parent ? this.layer_data.parent.id : null,
      };
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions('jStoreLayer', ['updateLayer', 'deleteLayer']),

    saveUpdateLayer() {
      // when .save() executed, getData method will run
      // and layer_data will contain value from data_layer
      this.$refs.layerForm.save();
      if (this.layer_data !== null) {
        // will call method in store
        this.updateLayer(this.generateData);
      }
    },

    onClickDelete() {
      this.$swal({
        title: 'Confirm Delete',
        text: 'Are you sure want to delete this layer?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.deleteLayer({ ids: [Number(this.$route.params.id)] });
        }
      });
    },

    getData(data) {
      this.layer_data = data;
    },

    closePage() {
      this.$router.replace('/company/organization');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layer/jLayerUpdate.vue